import React from 'react';
import { createRoot } from 'react-dom/client';
import MainApp from 'MainApp';

const container = document.getElementById('app-site');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<MainApp />);
